module.exports = __webpack_public_path__ + "prod/1.42.2/img/batch_show.4c013957.gif";